import React, { useState, useEffect } from 'react';
import {
  Layout, Typography, List, Avatar, Tag, Card, Tabs, Table, Descriptions,
  Radio, Input, Button, Space, Spin, message, Grid, Row, Col, Divider,
  Modal, Image, Badge, Collapse
} from 'antd';
import {
  CheckCircleOutlined, CloseCircleOutlined, EnvironmentOutlined,
  ShoppingOutlined, InfoCircleOutlined, ClockCircleOutlined,
  DollarOutlined, UserOutlined, FileTextOutlined, SearchOutlined,
  EyeOutlined, DownloadOutlined, PaperClipOutlined, FilePdfOutlined,
  FileImageOutlined, FileWordOutlined, FileExcelOutlined, FileUnknownOutlined
} from '@ant-design/icons';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../App';
import './bcs.css';

const { useBreakpoint } = Grid;
const { Content } = Layout;
const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { Panel } = Collapse;

const BCSAdminApproval = () => {
  const [loading, setLoading] = useState(false);
  const [reportList, setReportList] = useState([]);
  const [expandedDocNo, setExpandedDocNo] = useState(null);
  const [orderData, setOrderData] = useState(null);
  const [status, setStatus] = useState('');
  const [remarks, setRemarks] = useState('');
  const [activeTab, setActiveTab] = useState('1');
  const [searchTerm, setSearchTerm] = useState('');
  const [documents, setDocuments] = useState([]);
  const [itemDocuments, setItemDocuments] = useState({}); // New state for item-wise documents
  const [viewDocumentModal, setViewDocumentModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const screens = useBreakpoint();

  const MAINCODE = localStorage.getItem("LOGIN_ID");
  const SFA_Token = localStorage.getItem("SFA_Token");
  const headers = { Authorization: `Bearer ${SFA_Token}` };

  // Helper function to get file extension from mime type
  const getFileExtension = (mimeType) => {
    const mimeToExt = {
      'image/jpeg': 'jpg',
      'image/png': 'png',
      'image/gif': 'gif',
      'application/pdf': 'pdf',
      'application/msword': 'doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
      'application/vnd.ms-excel': 'xls',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      'text/plain': 'txt',
    };
    return mimeToExt[mimeType] || 'bin';
  };

  // Function to download all files for a specific item
  const downloadAllFilesForItem = (itemCode) => {
    const itemDocs = itemDocuments[itemCode] || [];
    if (itemDocs.length === 0) return;
    
    itemDocs.forEach((doc, index) => {
      setTimeout(() => {
        handleDownload(doc);
      }, index * 300);
    });
  };

  // Function to download all files for entire order
  const downloadAllFiles = () => {
    if (Object.keys(itemDocuments).length === 0) return;
    
    Object.values(itemDocuments).forEach(itemDocs => {
      itemDocs.forEach((doc, index) => {
        setTimeout(() => {
          handleDownload(doc);
        }, index * 300);
      });
    });
  };

  useEffect(() => {
    if (!MAINCODE) {
      Swal.fire({ icon: "warning", text: 'Login Failed!' });
      return;
    }
    fetchReportList();
  }, []);

  const fetchReportList = () => {
    setLoading(true);
    axios.post(`${BASE_URL}/bcs_Secondlevelapproval`, { login_id: MAINCODE })
      .then(res => setReportList(res.data || []))
      .catch(() => Swal.fire({ icon: "error", text: "Failed to load reports" }))
      .finally(() => setLoading(false));
  };

  // const fetchOrderDetails = (docNo) => {
  //   if (expandedDocNo === docNo) {
  //     setExpandedDocNo(null);
  //     setOrderData(null);
  //     setStatus('');
  //     setRemarks('');
  //     setDocuments([]);
  //     setItemDocuments({});
  //     return;
  //   }
  //   setExpandedDocNo(docNo);
  //   setOrderData(null);
  //   setStatus('');
  //   setRemarks('');
  //   setLoading(true);
  //   setActiveTab('1');
  //   axios.post(`${BASE_URL}/bcsorder_details`, { doc_no: docNo })
  //     .then(res => {
  //       setOrderData(res.data);
  //       processDocumentData(res.data.documents || {}, res.data.header, res.data.items || []);
  //     })
  //     .catch(err => Swal.fire({ icon: "error", text: err.response?.data?.message || "Failed to load order" }))
  //     .finally(() => setLoading(false));
  // };

  // Updated function to process documents by item
  // const processDocumentData = (documents, header, items) => {
  //   const documentTypes = [
  //     { key: 'wo_tech_data_sheet_path', name: 'Work Order / Technical Data Sheet', type: 'workOrder' },
  //     { key: 'technical_data_sheet_path', name: 'Technical Data Sheet', type: 'technicalDataSheet' },
  //     { key: 'cust_approved_gad_path', name: 'Customer Approved GAD', type: 'customerApprovedGAD' },
  //     { key: 'cust_approved_qap_path', name: 'Customer Approved QAP', type: 'customerApprovedQAP' },
  //     { key: 'drawing_file_path', name: 'Drawings', type: 'drawings' },
  //     { key: 'other_documents_path', name: 'Other Documents', type: 'otherDocuments' }
  //   ];

  //   // Group documents by item
  //   const itemDocsMap = {};
    
  //   // Initialize documents for each item
  //   items.forEach(item => {
  //     const itemCode = item.ITEM_CODE || item.ITEM || `ITEM_${item.ITEM}`;
  //     itemDocsMap[itemCode] = [];
  //   });

  //   // Process each document type and associate with items
  //   documentTypes.forEach(docType => {
  //     if (documents && documents[docType.key]) {
  //       const base64Data = documents[docType.key];
        
  //       // If we have multiple items, create document entries for each item
  //       if (items.length > 0) {
  //         items.forEach(item => {
  //           const itemCode = item.ITEM_CODE || item.ITEM || `ITEM_${item.ITEM}`;
  //           const itemDescription = item.ITEM_DESCRIPTION || item.DESCRIPTION || '';
            
  //           let fileName = `${itemCode}_${docType.name}`;
  //           let displayName = `${itemCode} - ${docType.name}`;
            
  //           if (itemDescription) {
  //             displayName = `${itemCode} - ${itemDescription} - ${docType.name}`;
  //           }

  //           const documentData = base64Data.startsWith('data:') 
  //             ? {
  //                 key: `${docType.key}_${itemCode}`,
  //                 file_name: fileName,
  //                 display_name: displayName,
  //                 file_type: docType.type,
  //                 file_path: null,
  //                 data_url: base64Data,
  //                 mime_type: base64Data.split(':')[1].split(';')[0],
  //                 item_code: itemCode,
  //                 item_description: itemDescription
  //               }
  //             : {
  //                 key: `${docType.key}_${itemCode}`,
  //                 file_name: fileName,
  //                 display_name: displayName,
  //                 file_type: docType.type,
  //                 file_path: null,
  //                 data_url: `data:${getMimeTypeFromBase64(base64Data)};base64,${base64Data}`,
  //                 mime_type: getMimeTypeFromBase64(base64Data),
  //                 item_code: itemCode,
  //                 item_description: itemDescription
  //               };

  //           itemDocsMap[itemCode].push(documentData);
  //         });
  //       } else {
  //         // Fallback: if no items, use generic document
  //         const genericDoc = base64Data.startsWith('data:') 
  //           ? {
  //               key: docType.key,
  //               file_name: docType.name,
  //               display_name: docType.name,
  //               file_type: docType.type,
  //               file_path: null,
  //               data_url: base64Data,
  //               mime_type: base64Data.split(':')[1].split(';')[0],
  //               item_code: 'GENERAL',
  //               item_description: 'General Documents'
  //             }
  //           : {
  //               key: docType.key,
  //               file_name: docType.name,
  //               display_name: docType.name,
  //               file_type: docType.type,
  //               file_path: null,
  //               data_url: `data:${getMimeTypeFromBase64(base64Data)};base64,${base64Data}`,
  //               mime_type: getMimeTypeFromBase64(base64Data),
  //               item_code: 'GENERAL',
  //               item_description: 'General Documents'
  //             };

  //         if (!itemDocsMap['GENERAL']) {
  //           itemDocsMap['GENERAL'] = [];
  //         }
  //         itemDocsMap['GENERAL'].push(genericDoc);
  //       }
  //     }
  //   });

  //   // Set the item-wise documents
  //   setItemDocuments(itemDocsMap);

  //   // Also maintain the flat list for backward compatibility if needed
  //   const allDocs = Object.values(itemDocsMap).flat();
  //   setDocuments(allDocs);
  // };
  // Updated function to process documents by material code
  const fetchOrderDetails = (docNo) => {
  if (expandedDocNo === docNo) {
    setExpandedDocNo(null);
    setOrderData(null);
    setStatus('');
    setRemarks('');
    setDocuments([]);
    setItemDocuments({});
    return;
  }
  setExpandedDocNo(docNo);
  setOrderData(null);
  setStatus('');
  setRemarks('');
  setLoading(true);
  setActiveTab('1');
  axios.post(`${BASE_URL}/bcsorder_details`, { doc_no: docNo })
    .then(res => {
      setOrderData(res.data);
      // Pass the documents array from response
      processDocumentData(res.data.documents || [], res.data.header, res.data.items || []);
    })
    .catch(err => Swal.fire({ icon: "error", text: err.response?.data?.message || "Failed to load order" }))
    .finally(() => setLoading(false));
};
const processDocumentData = (documentsArray, header, items) => {
  const documentTypes = [
    { key: 'wo_tech_data_sheet_path', name: 'Work Order / Technical Data Sheet', type: 'workOrder' },
    { key: 'technical_data_sheet_path', name: 'Technical Data Sheet', type: 'technicalDataSheet' },
    { key: 'cust_approved_gad_path', name: 'Customer Approved GAD', type: 'customerApprovedGAD' },
    { key: 'cust_approved_qap_path', name: 'Customer Approved QAP', type: 'customerApprovedQAP' },
    { key: 'drawing_file_path', name: 'Drawings', type: 'drawings' },
    { key: 'other_documents_path', name: 'Other Documents', type: 'otherDocuments' }
  ];

  // Group documents by material code
  const itemDocsMap = {};
  
  // Process each document entry in the array
  documentsArray.forEach(docEntry => {
    const matCode = docEntry.mat_code?.trim();
    if (!matCode) return;

    // Initialize array for this material code
    if (!itemDocsMap[matCode]) {
      itemDocsMap[matCode] = [];
    }

    // Find item details for this material code
    const itemInfo = items.find(item => 
      (item.ITEM_CODE && item.ITEM_CODE.trim() === matCode) || 
      (item.MAT_CODE && item.MAT_CODE.trim() === matCode) ||
      (item.ITEM && item.ITEM.toString().trim() === matCode)
    );

    const itemDescription = itemInfo?.ITEM_DESCRIPTION || itemInfo?.DESCRIPTION || '';

    // Process each document type for this material
    documentTypes.forEach(docType => {
      const documentData = docEntry.documents[docType.key];
      if (documentData && documentData.trim() !== '') {
        const base64Data = documentData;
        
        let fileName = `${matCode}_${docType.name}`;
        let displayName = `${matCode} - ${docType.name}`;
        
        if (itemDescription) {
          displayName = `${matCode} - ${itemDescription} - ${docType.name}`;
        }

        const documentObj = base64Data.startsWith('data:') 
          ? {
              key: `${docType.key}_${matCode}`,
              file_name: fileName,
              display_name: displayName,
              file_type: docType.type,
              file_path: null,
              data_url: base64Data,
              mime_type: base64Data.split(':')[1].split(';')[0],
              item_code: matCode,
              item_description: itemDescription,
              mat_code: matCode
            }
          : {
              key: `${docType.key}_${matCode}`,
              file_name: fileName,
              display_name: displayName,
              file_type: docType.type,
              file_path: null,
              data_url: `data:${getMimeTypeFromBase64(base64Data)};base64,${base64Data}`,
              mime_type: getMimeTypeFromBase64(base64Data),
              item_code: matCode,
              item_description: itemDescription,
              mat_code: matCode
            };

        itemDocsMap[matCode].push(documentObj);
      }
    });
  });

  // If no documents found in the array but we have items, create empty entries
  if (documentsArray.length === 0 && items.length > 0) {
    items.forEach(item => {
      const itemCode = item.ITEM_CODE?.trim() || item.MAT_CODE?.trim() || item.ITEM?.toString().trim();
      if (itemCode && !itemDocsMap[itemCode]) {
        itemDocsMap[itemCode] = [];
      }
    });
  }

  // Set the item-wise documents
  setItemDocuments(itemDocsMap);

  // Also maintain the flat list for backward compatibility if needed
  const allDocs = Object.values(itemDocsMap).flat();
  setDocuments(allDocs);
};

  // Helper function to detect mime type from base64
  const getMimeTypeFromBase64 = (base64Data) => {
    if (base64Data.startsWith('/9j/') || base64Data.startsWith('iVBORw')) {
      return 'image/jpeg';
    } else if (base64Data.startsWith('JVBERi')) {
      return 'application/pdf';
    } else if (base64Data.startsWith('UEsDB')) {
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    }
    return 'application/octet-stream';
  };

  const handleSubmit = () => {
    if (!status) return message.error("Select approval status.");
    if (!remarks.trim()) return message.error("Enter remarks.");

    setLoading(true);

    axios.post(`${BASE_URL}/bcssubmit_ho`, {
      docNo: orderData.header.DOC_NO,
      dealercode: orderData.header.DEALER_CODE,
      status,
      remarks,
      login_id: MAINCODE
    }, { headers })
      .then((res) => {
        const { doc_no, sap_order_no, message: apiMessage } = res.data;

        if (status === 'APPROVED' && sap_order_no) {
          Swal.fire({
            icon: 'success',
            title: 'Order Interfaced to SAP',
            html: `
              <b>DMS Order No:</b> ${doc_no}<br/>
              <b>SAP Order No:</b> ${sap_order_no}
            `
          });
        } else if (status === 'APPROVED' && !sap_order_no) {
          Swal.fire({
            icon: 'error',
            title: 'SAP Order Failed',
            text: 'Approval was rolled back as SAP Order was not created.'
          });
        } else if (status === 'REJECTED') {
          Swal.fire({
            icon: 'success',
            title: 'Order Rejected',
            text: apiMessage || 'Document rejected successfully.'
          });
        }

        setStatus('');
        setRemarks('');
        setExpandedDocNo(null);
        setOrderData(null);
        setDocuments([]);
        setItemDocuments({});
        fetchReportList();
      })
      .catch(err => {
        message.error(err.response?.data?.error || "Submit failed");
      })
      .finally(() => setLoading(false));
  };

  const getStatusColor = (type) => {
    switch (type) {
      case 'REGULAR': return 'blue';
      case 'SPECIAL': return 'orange';
      case 'URGENT': return 'red';
      default: return 'green';
    }
  };

  const formatCurrency = (amount) =>
    new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount).replace('₹', '₹ ');

  const viewDocument = (document) => {
    setSelectedDocument(document);
    setViewDocumentModal(true);
  };

  const getFileIcon = (document) => {
    if (!document) return <FileUnknownOutlined />;
    
    if (document.mime_type) {
      if (document.mime_type.startsWith('image/')) return <FileImageOutlined style={{ color: '#52c41a' }} />;
      if (document.mime_type === 'application/pdf') return <FilePdfOutlined style={{ color: '#f40f02' }} />;
      if (document.mime_type.includes('word')) return <FileWordOutlined style={{ color: '#1890ff' }} />;
      if (document.mime_type.includes('excel') || document.mime_type.includes('sheet')) 
        return <FileExcelOutlined style={{ color: '#52c41a' }} />;
    }
    
    return <FileUnknownOutlined />;
  };

  const renderDocumentContent = (document) => {
    if (!document || !document.data_url) {
      return <p>No document content available</p>;
    }

    if (document.mime_type.startsWith("image/")) {
      return (
        <div style={{ textAlign: "center" }}>
          <Image
            src={document.data_url}
            alt={document.file_name}
            style={{ maxWidth: "100%", maxHeight: "70vh" }}
          />
        </div>
      );
    }

    if (document.mime_type === "application/pdf") {
      return (
        <iframe
          src={document.data_url}
          title={document.file_name}
          style={{ width: "100%", height: "70vh", border: "none" }}
        />
      );
    }

    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <FileUnknownOutlined style={{ fontSize: 48, marginBottom: 16 }} />
        <p>Preview not available for this file type</p>
        <Button
          type="link"
          onClick={() => handleDownload(document)}
          icon={<DownloadOutlined />}
        >
          Download
        </Button>
      </div>
    );
  };

  const handleDownload = (doc) => {
    if (!doc || !doc.data_url) return;

    try {
      const base64Data = doc.data_url.split(',')[1];
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: doc.mime_type });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${doc.file_name}.${getFileExtension(doc.mime_type)}`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      message.error("Failed to download file");
    }
  };

  const filteredOrders = reportList.filter(order =>
    order.DOC_NO.toLowerCase().includes(searchTerm.toLowerCase()) ||
    order.DEALER.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const renderOrderHeader = (item) => (
    <Row gutter={16} align="middle" style={{ width: '100%' }}>
      <Col xs={24} sm={12} md={8}>
        <Space>
          <Avatar size={screens.xs ? 40 : 48} icon={<FileTextOutlined />} />
          <div>
            <Text strong style={{ fontSize: screens.xs ? 14 : 16 }}>{item.DEALER}</Text><br />
            <Text type="secondary">Order #{item.DOC_NO}</Text>
          </div>
        </Space>
      </Col>
      <Col xs={24} sm={12} md={8} style={{ textAlign: screens.xs ? 'left' : 'center' }}>
        <Text strong style={{ fontSize: screens.xs ? 14 : 16 }}>
          <ClockCircleOutlined />{' '}
          {new Date(item.DOC_DATE).toLocaleDateString('en-GB')}
        </Text>
      </Col>
      <Col xs={24} sm={24} md={8} style={{ textAlign: 'right' }}>
        <Space>
          <Text strong style={{ fontSize: screens.xs ? 16 : 18 }}>
            {item.PO_VALUE && !isNaN(item.PO_VALUE) ? formatCurrency(item.PO_VALUE) : '-'}
          </Text>
          {item.DOCTYPE_CODE && (
            <Tag color={getStatusColor(item.DOCTYPE_CODE)}>
              {item.DOCTYPE_CODE === 'URGENT' && <ClockCircleOutlined />} {item.DOCTYPE_CODE}
            </Tag>
          )}
        </Space>
      </Col>
    </Row>
  );

  const renderItemDocuments = () => {
  if (Object.keys(itemDocuments).length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: 24, border: '1px dashed #d9d9d9', borderRadius: 6 }}>
        <FileTextOutlined style={{ fontSize: 32, color: '#bfbfbf', marginBottom: 8 }} />
        <p style={{ color: '#bfbfbf' }}>No documents available for this order</p>
      </div>
    );
  }

  return (
    <Collapse defaultActiveKey={Object.keys(itemDocuments)}>
      {Object.entries(itemDocuments).map(([matCode, docs]) => {
        const itemInfo = orderData.items.find(item => 
          (item.ITEM_CODE && item.ITEM_CODE.trim() === matCode) ||
          (item.MAT_CODE && item.MAT_CODE.trim() === matCode) ||
          (item.ITEM && item.ITEM.toString().trim() === matCode)
        );
        const itemDescription = itemInfo?.ITEM_DESCRIPTION || itemInfo?.DESCRIPTION || '';
        
        return (
          <Panel 
            header={
              <Space>
                <Text strong>{matCode}</Text>
                {itemDescription && <Text type="secondary">- {itemDescription}</Text>}
                <Badge count={docs.length} showZero={false} />
              </Space>
            }
            key={matCode}
            extra={
              docs.length > 0 && (
                <Button 
                  type="link" 
                  size="small" 
                  icon={<DownloadOutlined />}
                  onClick={(e) => {
                    e.stopPropagation();
                    downloadAllFilesForItem(matCode);
                  }}
                >
                  Download All
                </Button>
              )
            }
          >
            <List
              dataSource={docs}
              renderItem={(doc) => (
                <List.Item
                  actions={[
                    <Button type="link" icon={<EyeOutlined />} onClick={() => viewDocument(doc)}>View</Button>,
                    <Button type="link" onClick={() => handleDownload(doc)} icon={<DownloadOutlined />}>
                      Download
                    </Button>
                  ]}
                >
                  <List.Item.Meta
                    avatar={getFileIcon(doc)}
                    title={doc.display_name || doc.file_name}
                    description={<Text type="secondary">Type: {doc.mime_type}</Text>}
                  />
                </List.Item>
              )}
            />
          </Panel>
        );
      })}
    </Collapse>
  );
};
  // const renderItemDocuments = () => {
  //   if (Object.keys(itemDocuments).length === 0) {
  //     return (
  //       <div style={{ textAlign: 'center', padding: 24, border: '1px dashed #d9d9d9', borderRadius: 6 }}>
  //         <FileTextOutlined style={{ fontSize: 32, color: '#bfbfbf', marginBottom: 8 }} />
  //         <p style={{ color: '#bfbfbf' }}>No documents available for this order</p>
  //       </div>
  //     );
  //   }

  //   return (
  //     <Collapse defaultActiveKey={Object.keys(itemDocuments)}>
  //       {Object.entries(itemDocuments).map(([itemCode, docs]) => {
  //         const itemInfo = orderData.items.find(item => 
  //           (item.ITEM_CODE || item.ITEM) === itemCode || `ITEM_${item.ITEM}` === itemCode
  //         );
  //         const itemDescription = itemInfo?.ITEM_DESCRIPTION || itemInfo?.DESCRIPTION || '';
          
  //         return (
  //           <Panel 
  //             header={
  //               <Space>
  //                 <Text strong>{itemCode}</Text>
  //                 {itemDescription && <Text type="secondary">- {itemDescription}</Text>}
  //                 <Badge count={docs.length} showZero={false} />
  //               </Space>
  //             }
  //             key={itemCode}
  //             extra={
  //               docs.length > 0 && (
  //                 <Button 
  //                   type="link" 
  //                   size="small" 
  //                   icon={<DownloadOutlined />}
  //                   onClick={(e) => {
  //                     e.stopPropagation();
  //                     downloadAllFilesForItem(itemCode);
  //                   }}
  //                 >
  //                   Download All
  //                 </Button>
  //               )
  //             }
  //           >
  //             <List
  //               dataSource={docs}
  //               renderItem={(doc) => (
  //                 <List.Item
  //                   actions={[
  //                     <Button type="link" icon={<EyeOutlined />} onClick={() => viewDocument(doc)}>View</Button>,
  //                     <Button type="link" onClick={() => handleDownload(doc)} icon={<DownloadOutlined />}>
  //                       Download
  //                     </Button>
  //                   ]}
  //                 >
  //                   <List.Item.Meta
  //                     avatar={getFileIcon(doc)}
  //                     title={doc.display_name || doc.file_name}
  //                     description={<Text type="secondary">Type: {doc.mime_type}</Text>}
  //                   />
  //                 </List.Item>
  //               )}
  //             />
  //           </Panel>
  //         );
  //       })}
  //     </Collapse>
  //   );
  // };

  return (
    <Layout style={{ background: '#f5f7fa', minHeight: '100vh' }}>
      <Content style={{ padding: screens.xs ? '16px' : '24px' }}>
        <div style={{
          maxWidth: 1200,
          margin: '0 auto',
          background: '#fff',
          borderRadius: 8,
          padding: screens.xs ? 16 : 24,
          boxShadow: '0 1px 2px 0 rgba(0,0,0,0.03)'
        }}>
          <div style={{ marginBottom: 24 }}>
            <Row justify="space-between" align="middle">
              <Col>
                <Title level={4} style={{ margin: 0 }}>
                  BCS Order Approvals
                </Title>
                <Text type="secondary">
                  {filteredOrders.length} pending order{filteredOrders.length !== 1 ? 's' : ''}
                </Text>
              </Col>
              <Col>
                <Input
                  placeholder="Search orders..."
                  prefix={<SearchOutlined />}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ width: 200 }}
                  allowClear
                />
              </Col>
            </Row>
          </div>

          {loading && !orderData ? (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              <Spin size="large" tip="Loading orders..." />
            </div>
          ) : (
            <List
              dataSource={filteredOrders}
              renderItem={item => (
                <Card
                  key={item.DOC_NO}
                  style={{
                    marginBottom: 16,
                    borderRadius: 8,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.09)',
                    border: expandedDocNo === item.DOC_NO ? '1px solid #1890ff' : '1px solid #f0f0f0'
                  }}
                  hoverable
                  onClick={(e) => {
                    if (
                      e.target.closest('button') ||
                      e.target.closest('.ant-radio-button-wrapper') ||
                      e.target.closest('textarea') ||
                      e.target.closest('input')
                    ) {
                      return;
                    }
                    fetchOrderDetails(item.DOC_NO);
                  }}
                >
                  {renderOrderHeader(item)}

                  {expandedDocNo === item.DOC_NO && orderData && (
                    <div style={{ marginTop: 24 }}>
                      <Divider style={{ margin: '16px 0' }} />

                      <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        tabBarStyle={{ marginBottom: 16 }}
                      >
                        <TabPane
                          key="1"
                          tab={
                            <span>
                              <ShoppingOutlined style={{ color: '#1890ff' }} /> 
                              Order Items ({orderData.items.length})
                            </span>
                          }
                        >
                          <Table
                            dataSource={orderData.items}
                            rowKey="ITEM"
                            pagination={false}
                            bordered
                            scroll={{ x: true }}
                            size="small"
                            columns={[
                              {
                                title: 'Item Code',
                                dataIndex: 'ITEM_CODE',
                                render: (text, record) => text || record.ITEM,
                                ellipsis: true
                              },
                              {
                                title: 'Description',
                                dataIndex: 'ITEM_DESCRIPTION',
                                render: (text, record) => text || record.DESCRIPTION,
                                ellipsis: true
                              },
                              {
                                title: 'Qty',
                                dataIndex: 'QTY',
                                align: 'right',
                                width: 100
                              },
                              {
                                title: 'Price',
                                dataIndex: 'PRICE',
                                align: 'right',
                                width: 120,
                                render: val => formatCurrency(val)
                              },
                              {
                                title: 'Total',
                                dataIndex: 'TOTAL',
                                align: 'right',
                                width: 140,
                                render: val => <Text strong>{formatCurrency(val)}</Text>
                              }
                            ]}
                          />
                        </TabPane>

                        <TabPane key="2" tab={<span><EnvironmentOutlined style={{ color: '#52c41a' }} /> Shipping Details</span>}>
                          <Descriptions bordered column={1} size="small">
                            <Descriptions.Item label="Address">
                              {orderData.address.address1}, {orderData.address.City}, {orderData.address.State} - {orderData.address.Pincode}
                            </Descriptions.Item>
                            <Descriptions.Item label="Contact Person">
                              <UserOutlined /> {orderData.address.Name} - {orderData.address.Contactnumber}
                            </Descriptions.Item>
                            <Descriptions.Item label="GST Number">
                              {orderData.address.GSTNUMBER || 'N/A'}
                            </Descriptions.Item>
                          </Descriptions>
                        </TabPane>

                        {/* Updated Documents Tab with Item-wise separation */}
                        <TabPane key="3" tab={
                          <span>
                            <PaperClipOutlined style={{ marginRight: 8 }} />
                            Documents
                            {documents.length > 0 && <Badge count={documents.length} style={{ marginLeft: 8 }} />}
                          </span>
                        }>
                          <Card 
                            bordered={false} 
                            style={{ marginBottom: 24 }} 
                            bodyStyle={{ padding: screens.md ? 16 : 12 }}
                            extra={
                              documents.length > 0 && (
                                <Button 
                                  type="primary" 
                                  icon={<DownloadOutlined />}
                                  onClick={downloadAllFiles}
                                  size="small"
                                >
                                  Download All
                                </Button>
                              )
                            }
                          >
                            {renderItemDocuments()}
                          </Card>
                        </TabPane>
                      </Tabs>

                      {orderData.level1_approver?.length > 0 && (
                        <Card
                          title={<span><CheckCircleOutlined style={{ color: '#389e0d' }} /> Level 1 Approval</span>}
                          style={{ marginTop: 16, background: '#f6ffed', border: '1px solid #b7eb8f' }}
                          headStyle={{ borderBottom: '1px solid #d9f7be' }}
                        >
                          {orderData.level1_approver.map((approver, idx) => (
                            <Row key={idx} gutter={16} style={{ marginBottom: idx !== orderData.level1_approver.length - 1 ? 12 : 0 }}>
                              <Col span={8}><Text strong>By:</Text> {approver.LEVEL1_APPROVED_BY}</Col>
                              <Col span={8}><Text strong>On:</Text> {approver.LEVEL1_APPROVED_ON}</Col>
                              <Col span={8}><Text strong>Comments:</Text> {approver.LEVEL1_COMMENTS || '—'}</Col>
                            </Row>
                          ))}
                        </Card>
                      )}

                      <Card
                        title={<span><FileTextOutlined style={{ color: '#fa8c16' }} /> Approval Decision</span>}
                        style={{ marginTop: 24 }}
                        headStyle={{ borderBottom: '1px solid #f0f0f0' }}
                      >
                        <Space direction="vertical" style={{ width: '100%' }}>
                          <Radio.Group
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            buttonStyle="solid"
                            size="large"
                            style={{ width: '100%' }}
                          >
                            <Radio.Button value="APPROVED" style={{ width: '50%', textAlign: 'center', color: '#389e0d' }}>
                              <CheckCircleOutlined /> 
                              Approve
                            </Radio.Button>
                            <Radio.Button value="REJECTED" style={{ width: '50%', textAlign: 'center', color: '#cf1322' }}>
                              <CloseCircleOutlined /> Reject
                            </Radio.Button>
                          </Radio.Group>

                          <Input.TextArea
                            rows={4}
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            maxLength={500}
                            showCount
                            placeholder="Enter your approval remarks..."
                            style={{ margin: '16px 0' }}
                          />

                          <Button
                            type="primary"
                            size="large"
                            loading={loading}
                            disabled={!status || !remarks.trim()}
                            icon={status === 'APPROVED' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                            onClick={handleSubmit}
                            block
                            style={{ height: 48 }}
                          >
                            {status ? `Submit as ${status}` : 'Submit Decision'}
                          </Button>
                        </Space>
                      </Card>
                    </div>
                  )}
                </Card>
              )}
              locale={{
                emptyText: (
                  <div style={{
                    textAlign: 'center',
                    padding: 48,
                    background: '#fafafa',
                    borderRadius: 8
                  }}>
                    <CheckCircleOutlined style={{
                      fontSize: 48,
                      color: '#52c41a',
                      marginBottom: 16
                    }} />
                    <Title level={4} style={{ marginBottom: 8 }}>
                      No Pending Approvals
                    </Title>
                    <Text type="secondary">
                      All orders have been processed
                    </Text>
                  </div>
                )
              }}
            />
          )}
        </div>
      </Content>

      {/* Document View Modal */}
      <Modal
        title={selectedDocument?.display_name || selectedDocument?.file_name}
        open={viewDocumentModal}
        onCancel={() => setViewDocumentModal(false)}
        footer={[
          <Button key="close" onClick={() => setViewDocumentModal(false)}>Close</Button>,
          selectedDocument && (
            <Button key="download" type="primary" onClick={() => handleDownload(selectedDocument)}>
              Download
            </Button>
          )
        ]}
        width={800}
        style={{ top: 20 }}
      >
        {selectedDocument && renderDocumentContent(selectedDocument)}
      </Modal>
    </Layout>
  );
};

export default BCSAdminApproval;